import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import LoadingComponent from "../../utility/LoadingComponent";
import { memo } from "react";

function DashboardCashout({
  returnData,
  channelSalesData,
  loading,
  digitalSalesData,
  cashSalesData,
  tnsAppData,
  creditData,
  returnTotal
}: any) {
  let today: string | Date = new Date();
  let dd: number | string = today.getDate();
  let mm: number | string = today.getMonth() + 1;
  let yyyy: number = today.getFullYear();

  today = mm + "/" + dd + "/" + yyyy;
  today = new Date(Date?.parse(today))?.toLocaleDateString();
  // const sum = returnData
  //   .map(
  //     (item: any) =>parseInt(item.returnamount))
  //   .reduce((prev: string, curr: string) => prev + curr, 0);

  return (
    <>
      {/* <h3>Cash Outs</h3> */}
      {loading === true ? (
        <LoadingComponent />
      ) : (
        <>
          <List>
            <ListItem divider>
              <ListItemText primary="Cash Sales: " /> {Math.round(cashSalesData)}
            </ListItem>
            <ListItem>
              <ListItemText primary="Digital Sales(UPI+Cards)" />
              {Math.round(digitalSalesData)}
            </ListItem>
            <Divider light />
            <ListItem>
              <ListItemText primary="Zomato/Swiggy/ONDC" />
              {Math.round(channelSalesData)}
            </ListItem>
            <Divider light />
            <ListItem>
              <ListItemText primary="Credit Sales: " />
              {Math.round(creditData)}
            </ListItem>
            <Divider light />
            <ListItem>
              <ListItemText primary="Tns-App" />
                      {Math.round(tnsAppData)}
            </ListItem>
            <Divider light />
            <ListItem>
              <ListItemText primary="Returns" />
              {Math.round(returnTotal)}
            </ListItem>
            <Divider light />
            <ListItem>
              <ListItemText primary="Total Sales" />
              {Math.round(cashSalesData + digitalSalesData + channelSalesData + creditData + tnsAppData - returnTotal)}
            </ListItem>
          </List>
          <Divider />
        </>
      )}
    </>
  );
}

export default memo(DashboardCashout);
